import { TableName } from '@openx/components-table/Table.tsx';
import type { SynchronizedWith } from '@openx/types/deal.ts';
import { useMemo } from 'react';
import { FAILED_TO_SYNC_STATUS } from '../constants.ts';
import { SyncErrorsSection } from './SyncErrorsSection.tsx';

type AmazonSyncErrorsSectionProps = {
  amazonLastSyncError?: NonNullable<SynchronizedWith['amazon_sync']>['amazon_last_sync_error'];
  syncStatus: string | undefined;
};

export const AmazonSyncErrorsSection = ({ amazonLastSyncError, syncStatus }: AmazonSyncErrorsSectionProps) => {
  const hasErrorsToShow = !!amazonLastSyncError?.errors?.length && syncStatus === FAILED_TO_SYNC_STATUS;

  const errors = useMemo(
    () => (hasErrorsToShow ? (amazonLastSyncError?.errors ?? []) : []),
    [hasErrorsToShow, amazonLastSyncError?.errors]
  );

  return (
    <SyncErrorsSection
      errors={errors}
      lastErrorDatetime={amazonLastSyncError?.last_error_datetime}
      tableName={TableName.DEAL_AMAZON_SYNC_ERRORS}
    />
  );
};
